webpackJsonp([14],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(68);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _manual = __webpack_require__(251);
	
	var _manual2 = _interopRequireDefault(_manual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	new _vue2.default({
	  el: '#app',
	  template: '<manual/>',
	  components: { manual: _manual2.default }
	});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var apiLinks = void 0;
	var enterpriseId = 477;
	
	var yc = 'https://yc.yonyoucloud.com';
	var curlinks = 'http://' + window.location.host;
	exports.apiLinks = apiLinks = {
	  materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
	
	  southCement: {
	    home: 'http://www.scement.cn/cn/'
	  },
	  caslogout: yc + '/yuncai/caslogout/all?logouturl=' + window.location.host + '/caslogout',
	
	  register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=nfsn',
	
	  enterWorkbench: yc + '/yuncai/pubportal/redirect2workbench.html?ipuid=nfsn&redirectsrc=' + curlinks,
	
	  suppliersFor: yc + '/yuncai/SSO/registerredirect.html?v=' + Date.parse(new Date().toLocaleDateString()),
	
	  infoTable: {
	    latest: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'latest2', 'latest3'],
	    area: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'area2', 'area3', 'area4', 'area5', 'area6', 'area7', 'area8'],
	    type: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', '2', '3', '4']
	  },
	
	  purchasetableDate: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=5&pageSize=10&pageIndex=0'],
	
	  logisticstableDate: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0'],
	
	  dealtableDate: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=bidauction&supEnterpriseIds=' + enterpriseId + '&status=15&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=bidauction&supEnterpriseIds=' + enterpriseId + '&status=17&pageSize=10&pageIndex=0'],
	
	  details: {
	    bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
	    bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
	    bidNotice: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
	    bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
	    inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
	    jingjia: yc + '/cpu-bidauction-fe/bidding_Apply/index.zh_CN.html?id=',
	    company: yc + '/gwmanage/pages/notice/detail.html?id=',
	    bidauctionNotice: yc + '/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id='
	  },
	
	  notice: {
	    company: yc + '/yuncai/jsonp/entnotice?appcode=cpu&tenantid=eci0x4ex&pageSize=6',
	    bidding: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageIndex=0&pageSize=6',
	    clarify: ''
	  },
	
	  contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId
	};
	exports.apiLinks = apiLinks;

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(3);
	
	exports.default = {
	  name: 'gheader',
	  props: {
	    type: ''
	  },
	  data: function data() {
	    return {
	      southCement: _links.apiLinks.southCement['home'],
	      enterWorkbench: _links.apiLinks.enterWorkbench,
	      caslogout: _links.apiLinks.caslogout
	    };
	  }
	};

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'grednav',
	  props: {
	    type: ''
	  }
	};

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(19)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(25)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(17)
	
	/* template */
	var __vue_template__ = __webpack_require__(23)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(18)
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(24)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-logo"
	  }, [_c('div', {
	    staticClass: "main-width set-position"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/logo@1x.png",
	      "width": "253px",
	      "height": "54px",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "float": "right",
	      "margin-top": "5px"
	    }
	  }, [_c('span', {
	    staticClass: "row-logo-right2"
	  }, [_vm._v("如需技术帮助，可咨询以下QQ:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "row-logo-right2"
	  }, [_vm._v("咨询QQ： 2864465221")]), _vm._v("\n        \n      "), _c('span', {
	    staticClass: "row-logo-right2"
	  }, [_vm._v("1227370263")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "row-logo-right2"
	  }, [_vm._v("供应商操作视频链接：  http://pan.baidu.com/s/1eSsYnXg")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "row-logo-right2"
	  }, [_vm._v("如需业务帮助，请咨询联系招标的业务人员.")])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group pull-right hidden"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "搜索商机/物资"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/search.png"
	    }
	  })])])])])])
	}]}

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-red-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('ul', {
	    staticClass: "list-basic-settings",
	    attrs: {
	      "id": "red-nav-navbar"
	    }
	  }, [_c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "purchase.html"
	    }
	  }, [_vm._v("物资招标")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "logistics.html"
	    }
	  }, [_vm._v("物流招标")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "deal.html"
	    }
	  }, [_vm._v("竞买竞卖")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "notice.html"
	    }
	  }, [_vm._v("公告信息")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "contact.html"
	    }
	  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "http://www.scement.cn/cn"
	    }
	  }, [_vm._v("返回官网")])])])])])
	}]}

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "row-nav-navbar"
	    }
	  }, [_c('ul', {
	    staticClass: "list-basic-settings pull-right"
	  }, [(_vm.type == 'home') ? [_vm._m(0)] : [_vm._m(1)], _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.enterWorkbench
	    }
	  }, [_vm._v("工作中心")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
	    staticClass: "home-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.southCement
	    }
	  }, [_vm._v("返回官网")])]), _vm._v(" "), _c('li', {
	    staticClass: "cashome-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.southCement
	    }
	  }, [_vm._v("返回官网")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
	    staticClass: "cashome-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.caslogout
	    }
	  }, [_vm._v("退出")])])], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   |  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "cashome.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   |  ")])
	}]}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GHeader = __webpack_require__(20);
	
	var _GHeader2 = _interopRequireDefault(_GHeader);
	
	var _GLogo = __webpack_require__(21);
	
	var _GLogo2 = _interopRequireDefault(_GLogo);
	
	var _GRednav = __webpack_require__(22);
	
	var _GRednav2 = _interopRequireDefault(_GRednav);
	
	var _links = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    gheader: _GHeader2.default,
	    glogo: _GLogo2.default,
	    grednav: _GRednav2.default
	  },
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    enterlink: function enterlink() {
	      var str = window.location.href;
	      var array = str.split('?');
	      if (array[1] === 'register') {
	        window.location.href = _links.apiLinks.register;
	      } else if (array[1] === 'applyFor') {
	        window.location.href = _links.apiLinks.suppliersFor;
	      }
	    }
	  }
	};

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(232)
	
	/* script */
	__vue_exports__ = __webpack_require__(200)
	
	/* template */
	var __vue_template__ = __webpack_require__(268)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('gheader', {
	    attrs: {
	      "type": "home"
	    }
	  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav', {
	    attrs: {
	      "type": "home"
	    }
	  }), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-agreement"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "agreement"
	    }
	  }, [_c('h2', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("供应商操作手册")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "source"
	    }
	  }, [_c('p')]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('h4', [_vm._v("一、供应商须知")]), _vm._v(" "), _c('p', [_vm._v("尊敬的供应商：")]), _vm._v(" "), _c('p', [_vm._v("你好！")]), _vm._v(" "), _c('p', [_vm._v("目前南方水泥已经上线了网上招标采购系统，未来我们会招标的很多流程都会放在网上，期待您注册网上招采平台跟南方水泥长期合作。")]), _vm._v(" "), _c('p', [_vm._v("为了帮助您更好的了解和掌握此系统，我们编写的以下操作手册，希望能够帮到您。以后如果在使用过程中遇到问题，一定要记得及时联系我们哦。")]), _vm._v(" "), _c('h4', [_vm._v("二、供应商申请流程")]), _vm._v(" "), _c('p', [_vm._v("1.网上招采地址")]), _vm._v(" "), _c('p', [_vm._v("请在浏览器中输入地址http://etb.scement.cn 登陆南方水泥招采平台。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual1.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("2.供应商注册")]), _vm._v(" "), _c('p', [_vm._v("希望参加南方水泥采购招标的供应商需要在网上申请成为南方水泥的供应商。")]), _vm._v(" "), _c('p', [_vm._v("2.1 开始注册")]), _vm._v(" "), _c('p', [_vm._v("点击“供应商注册”按钮开始注册。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual2.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("2.2 确认相关条款")]), _vm._v(" "), _c('p', [_vm._v("同意并继续后开始填写相关资料")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual3.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("2.3 填写账号信息")]), _vm._v(" "), _c('p', [_vm._v("手机号：需要用手机号进行注册（一个手机号只能注册一个账号）")]), _vm._v(" "), _c('p', [_vm._v("账号：即登录南方水泥进行报名，投标等操作的账号（账号必须是唯一的无法重复）")]), _vm._v(" "), _c('p', [_vm._v("密码：账户的密码")]), _vm._v(" "), _c('p', [_vm._v("企业名称：请确认是公司全称，注册后无法修改。")]), _vm._v(" "), _c('p', [_vm._v("相关信息填写完整后点击“下一步，完善供应商信息”系统会提示“您的账号已经注册成功”")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual4.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("2.4 完善供应商信息")]), _vm._v(" "), _c('p', [_vm._v("完善供应商注册信息有两种方式，一种是继续完善供应商资料，另一种时登录账号继续完善相关资料。（两种方式选择一种即可）")]), _vm._v(" "), _c('p', [_vm._v("供应商名称：由上一步代入")]), _vm._v(" "), _c('p', [_vm._v("管理组织：即确定您提交的资料由哪一家公司审核。")]), _vm._v(" "), _c('p', [_vm._v("供应商资质信息：请选择是上传三证还是五证，并需要填写相关证件账号。")]), _vm._v(" "), _c('p', [_vm._v("供应品类：即您要申请的供货类别（请如实填写）")]), _vm._v(" "), _c('p', [_vm._v("2.4.1 继续完善资料")]), _vm._v(" "), _c('p', [_vm._v("相关资料填写完成后点击“提交采购商审核即可”。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual5.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("2.4.2 登录账号完善资料。")]), _vm._v(" "), _c('p', [_vm._v("2.4.2.1 返回南方水泥招采平台，点击按钮“立即登录”。输入“账号”“密码”后登录。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual6.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("2.4.2.2 登录后点击“供应商申请”按钮填写供应商相关资料。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual7.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("\n            同意相关条款后，直接到供应商资料填写页面，填写完相关资料后，提交采购商审核即可\n          ")]), _vm._v(" "), _c('p', [_vm._v("三、查看供应商审核是否通过")]), _vm._v(" "), _c('p', [_vm._v("3.1 账号登录")]), _vm._v(" "), _c('p', [_vm._v("登录供应商账号，登录后点击进入工作台。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual8.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual9.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("3.2 查看供应商申请界面")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual10.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("3.3 查看审核是否通过")]), _vm._v(" "), _c('p', [_vm._v("待审核状态可以查看相关供应商资料，申请被驳回后，可以修改相关资料重新提交，申请通过后可以参加南方水泥相关企业的采购招标。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual11.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("三、供应商招标")]), _vm._v(" "), _c('p', [_vm._v("1.供应商报名")]), _vm._v(" "), _c('p', [_vm._v("供应商报名分两种情况，一种是邀请报名，一种是直接报名。")]), _vm._v(" "), _c('p', [_vm._v("1.1 邀请报名")]), _vm._v(" "), _c('p', [_vm._v("直接登录账号即可，登录账户，进入工作台，投标管理，在报名中查看“待报名”的数量，点击“报名”按钮，填写相关资料报名即可。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual12.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("1.2 直接报名")]), _vm._v(" "), _c('p', [_vm._v("在南方水泥招采门户，查询招标信息，点击相关招标信息，点击我要报名，然后登录后，点击报名，填写相关资料后，点击“报名”即可")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual13.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual14.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual15.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual16.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("2.供应商招标")]), _vm._v(" "), _c('p', [_vm._v("2.1 供应商投标")]), _vm._v(" "), _c('p', [_vm._v("\n            登录账号如果在招标管理，在待投标里可以看到可以投标的数量，上传附件，输入报价，点击“保存”“投标”按钮即可。采购商如果对报价不满意，可以发起谈判，然后供应商可以在“待投标”进行报价。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual17.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual18.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual19.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("3.中标通知")]), _vm._v(" "), _c('p', [_vm._v("中标后供应商账号和招标门户都会收到中标通知。")]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual20.png",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual21.png",
	      "alt": ""
	    }
	  })])])])])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/api/manual.135cfce99ea1acb8a8e9.js